import { Paths } from "Shared/Utils";
import { useCallback } from "react";
import { useNavigate } from "react-router";

export const useLink = (path: string, isV1?: boolean, openInNewTab?: boolean, onActivate?: () => void) => {
    const navigate = useNavigate();
    const isExternalLink = path.startsWith("http") || path.startsWith("mailto:") || path.startsWith("tel:");

    const href = isV1 || isExternalLink ? path : Paths.getFullPath(path);

    const executeNavigation = useCallback(() => {
        if (onActivate) {
            onActivate();
        } else if (isV1 || openInNewTab || isExternalLink) {
            window.open(href, "_blank");
        } else {
            navigate(path);
        }
    }, [onActivate, isV1, openInNewTab, isExternalLink, href, navigate, path]);

    const onClick = useCallback(
        (event: React.MouseEvent<HTMLElement>) => {
            event.stopPropagation();
            if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
                return;
            }
            event.preventDefault();
            executeNavigation();
        },
        [executeNavigation]
    );

    const onKeyDown = useCallback(
        (e: React.KeyboardEvent) => {
            if (e.key === "Enter" || e.key === " ") {
                e.stopPropagation();
                if (onActivate) {
                    e.preventDefault();
                }
                executeNavigation();
            }
        },
        [executeNavigation, onActivate]
    );

    return {
        href: onActivate ? undefined : href,
        onClick,
        onKeyDown
    };
};
